<template>
  <div id="zipWidget"></div>
</template>

<script>
export default {
  props: ["amount", "load"],
  watch: {
    amount: function (val) {
      this.setScript();
    },
  },
  methods: {
    setScript() {
      const zipWidget = document.getElementById("zipWidget");
      let zipWidgetScript = document.createElement("script");
      zipWidgetScript.setAttribute(
        "src",
        `https://widgets.partpay.co.nz/zip-widget-classic-v3.0.0.js?max=2000&amount=${this.amount}&locale=nz`
      );
      zipWidgetScript.async = true;
      if (zipWidget.firstChild) {
        zipWidget.innerHTML = "";
      }
      zipWidget.appendChild(zipWidgetScript);
    },
  },
  mounted() {
    if (this.load) {
      this.$nextTick(() => this.setScript());
    }
  },
};
</script>